export const CLEWORD_DEFAULT_TITLE = '风变课灵小馆'

export const CHINA_COUNTRY_CODE  = '+86'

export const AUTHING_WECHAT_LOGIN_CALLBACK = '/auth/link-wechat-callback'